import { useAuthenticatedUser } from "@/hooks/useAuthenticatedUser";
import { useHotel } from "@/hooks/useHotel";
import { useSelectedHotelId } from "@/utils/hotelContext";

export const useCurrentHotelId = (): string | null => {
  const { userProfile } = useAuthenticatedUser();
  const { hotelId } = useHotel();
  const selectedHotelId = useSelectedHotelId();

  return selectedHotelId ?? userProfile?.profile?.hotelId ?? hotelId ?? null;
};
